import React, { useState, useEffect } from 'react';
import { useMyContext } from '../../../context/MyContext';
import NavBar from '../../../component/b2c/navBar/navBar';
import Sidebar from '../../../component/b2c/sidebar/sidebar';
import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import axios from 'axios';
import { FaUserPlus, FaUserCog, FaEnvelope, FaLock, FaPhone, FaBuilding, FaBriefcase, FaArrowLeft } from "react-icons/fa";
import { toast } from 'react-toastify';
import '../../../css/custom-scrollbar.css';
import { useNavigate } from 'react-router-dom';
import Select from "react-dropdown-select";
import { Base_Url, addEmployee } from '../../../config/config';
import { FiEye, FiEyeOff } from 'react-icons/fi';

const schema = z.object({
    name: z.string().min(1, "Name is required"),
    email: z.string().email("Invalid email address"),
    password: z.string().min(8, "Password must be at least 8 characters"),
    department: z.string().min(1, "Department is required"),
    phone: z.string().length(10, "Phone number must be 10 digits"),
    role: z.string().min(1, "Role is required"),
    company_name: z.string().min(1, "Company name is required")
});

const AddUser = () => {
    const token = localStorage.getItem('token');
    const naviagteToAllEmployee = useNavigate();
    const cus_id = localStorage.getItem('cus_id');
    const [showPassword, setShowPassword] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { isToggleSidebar, isDarkMode } = useMyContext();
    const [roles, setRoles] = useState([
        { id: "PXROLE67e68d8fd9990", name: "Admin" },
        { id: "PXROLE67e68d8fd9991", name: "Manager" },
        { id: "PXROLE67e68d8fd9992", name: "Employee" }
    ]);

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        setValue,
    } = useForm({
        resolver: zodResolver(schema),
        defaultValues: {
            name: "",
            email: "",
            password: "",
            department: "",
            phone: "",
            role: "",
            company_name: ""
        }
    });

    const onErrors = () => {
        toast.error("Please fix the errors in the form.");
    };

    const handleInputChange = (event) => {
        const { value, id } = event.target;

        if (id === 'phone') {
            const filteredValue = value.replace(/[^0-9]/g, '');
            event.target.value = filteredValue;
        }

        if (['name', 'department', 'company_name'].includes(id)) {
            const filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
            event.target.value = filteredValue;
        }
    };

    const handleSelectChange = (selectedValues) => {
        if (selectedValues && selectedValues.length > 0) {
            setValue('role', selectedValues[0].id);
        }
    };

    const onSubmit = async (data) => {
        const apiurl = Base_Url + addEmployee;
        setIsSubmitting(true);
        try {
            const response = await axios.post(
                apiurl,
                data,
                {
                    headers: {
                        token,
                        'Content-Type': 'application/json',
                        cus_id: cus_id
                    }
                }
            );
            if (response.data.status === "SUCCESS") {
                toast.success(response.data.message);
                naviagteToAllEmployee("/allEmployee");
                reset();
                setIsSubmitting(false);
            }
            else {
                toast.error(response.data.message?.email || response.data.message?.password);
                setIsSubmitting(false);
            }
        } catch (error) {
            toast.error(error || error?.email?.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    // ✅ Premium compact input styling
    const inputClass = (hasError) =>
        `w-full pl-9 pr-3 py-2 text-[11px] rounded-xl border transition-all duration-300 outline-none ${
            isDarkMode
                ? 'bg-white/[0.03] text-white placeholder-gray-500 border-white/10 hover:border-white/20'
                : 'bg-white text-gray-800 placeholder-gray-400 border-gray-200'
        } ${
            hasError
                ? 'border-rose-400 dark:border-rose-500/60 focus:ring-2 focus:ring-rose-500/20'
                : isDarkMode
                    ? 'focus:ring-2 focus:ring-indigo-500/25 focus:border-indigo-500/60 focus:bg-white/[0.06] focus:shadow-[0_0_15px_rgba(99,102,241,0.15)]'
                    : 'focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500'
        }`;

    const iconWrapClass = `absolute left-2.5 top-1/2 -translate-y-1/2 w-5 h-5 rounded-md flex items-center justify-center transition-all duration-300 ${
        isDarkMode ? 'bg-white/[0.04] border border-white/[0.06]' : 'bg-gray-100'
    }`;

    const labelClass = `block text-[9px] font-bold mb-1 uppercase tracking-[0.1em] flex items-center gap-1.5 ${
        isDarkMode ? 'text-gray-400' : 'text-gray-500'
    }`;
    const errorClass = `text-[9px] mt-1 font-semibold ${isDarkMode ? 'text-rose-400' : 'text-red-500'}`;

    const glass =
        "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
        "border border-white/60 dark:border-white/10 " +
        "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";

    return (
        <div className={`h-screen flex flex-col overflow-hidden transition-colors duration-300 ${
            isDarkMode ? 'dark bg-[#0B1120]' : 'bg-gray-50'
        }`}>
            {/* Premium ambient glows */}
            {isDarkMode && (
                <>
                    <div className="pointer-events-none absolute -top-40 -left-32 h-[500px] w-[500px] rounded-full bg-indigo-600/15 blur-[120px]" />
                    <div className="pointer-events-none absolute bottom-0 -right-32 h-[400px] w-[400px] rounded-full bg-purple-600/10 blur-[100px]" />
                </>
            )}

            <div className="z-10 shrink-0">
                <NavBar />
            </div>
            <div className="flex flex-1 overflow-hidden relative z-10">
                                   <div
                           className={`
                             ${isToggleSidebar ? "w-64" : "w-[72px]"}
                             m-3
                             rounded-3xl
                             ${glass}
                             overflow-hidden
                             transition-all
                             duration-300
                             ease-in-out
                           `}
                         >
                           <Sidebar />
                         </div>

                {/* ✅ Centered compact layout */}
                <div className={`flex-1 p-3 md:p-5 w-full overflow-hidden flex items-center justify-center transition-colors duration-300 ${
                    isDarkMode ? 'bg-[#0B1120]' : 'bg-gray-100'
                }`}>
                    <div className="w-full max-w-4xl">

                        {/* Premium Header */}
                        <div className="mb-3">
                            <div className="flex items-center gap-3">
                                <div className={`p-2 rounded-xl border transition-all duration-300 ${
                                    isDarkMode
                                        ? 'bg-gradient-to-br from-sky-500/20 to-blue-500/10 border-sky-500/30 shadow-[0_0_20px_rgba(14,165,233,0.2)]'
                                        : 'bg-white border-gray-200 shadow-sm'
                                }`}>
                                    <FaUserPlus size={16} className={isDarkMode ? 'text-sky-400' : 'text-blue-600'} />
                                </div>
                                <div>
                                    <h2 className={`text-sm font-bold tracking-tight transition-colors duration-300 ${
                                        isDarkMode ? 'text-white' : 'text-gray-800'
                                    }`}>Add New User</h2>
                                    <p className={`text-[10px] transition-colors duration-300 ${
                                        isDarkMode ? 'text-gray-500' : 'text-gray-400'
                                    }`}>Create a new employee account</p>
                                </div>
                            </div>
                        </div>

                        {/* Premium Form Card with subtle gradient border */}
                        <div className={`relative rounded-2xl p-[1px] transition-all duration-300 ${
                            isDarkMode
                                ? 'bg-gradient-to-br from-indigo-500/40 via-purple-500/20 to-pink-500/30'
                                : 'bg-gray-200'
                        }`}>
                            <div className={`rounded-2xl overflow-hidden ${
                                isDarkMode
                                    ? 'bg-gradient-to-br from-[#0F172A] via-[#111827] to-[#0F172A]'
                                    : 'bg-white'
                            }`}>

                                {/* Form Header */}
                                <div className={`px-4 py-3 border-b flex items-center gap-2 ${
                                    isDarkMode
                                        ? 'bg-gradient-to-r from-indigo-500/[0.08] via-purple-500/[0.05] to-transparent border-white/[0.06]'
                                        : 'bg-gray-50 border-gray-100'
                                }`}>
                                    <div className={`p-1.5 rounded-lg ${
                                        isDarkMode
                                            ? 'bg-indigo-500/10 border border-indigo-500/30'
                                            : 'bg-blue-50 border border-gray-300'
                                    }`}>
                                        <FaUserCog size={12} className={isDarkMode ? 'text-indigo-400' : 'text-blue-600'} />
                                    </div>
                                    <span className={`text-[10px] font-bold uppercase tracking-[0.15em] ${
                                        isDarkMode ? 'text-indigo-300' : 'text-gray-600'
                                    }`}>Employee Details</span>
                                    <span className={`ml-auto text-[9px] font-medium ${
                                        isDarkMode ? 'text-gray-500' : 'text-gray-400'
                                    }`}>
                                        <span className={isDarkMode ? 'text-rose-400' : 'text-red-500'}>*</span> Required fields
                                    </span>
                                </div>

                                {/* Form Body */}
                                <div className="p-4">
                                    <form onSubmit={handleSubmit(onSubmit, onErrors)}>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">

                                            {/* Role - Full width */}
                                            <div className="md:col-span-2">
                                                <label htmlFor="role" className={labelClass}>
                                                    <FaBriefcase size={10} className={isDarkMode ? 'text-amber-400' : 'text-amber-600'} />
                                                    Select Role
                                                    <span className={isDarkMode ? 'text-rose-400' : 'text-red-500'}>*</span>
                                                </label>
                                                <Select
                                                    options={roles}
                                                    labelField="name"
                                                    valueField="id"
                                                    placeholder="Select role..."
                                                    style={{
                                                        padding: '0.45rem 0.75rem',
                                                        fontSize: '11px',
                                                        borderRadius: '0.75rem',
                                                        width: '100%',
                                                        borderColor: isDarkMode ? 'rgba(255,255,255,0.1)' : '#d1d5db',
                                                        backgroundColor: isDarkMode ? 'rgba(255,255,255,0.03)' : '#ffffff',
                                                        color: isDarkMode ? '#fff' : '#000',
                                                        minHeight: '36px',
                                                    }}
                                                    dropdownStyle={{
                                                        backgroundColor: isDarkMode ? '#0F172A' : '#ffffff',
                                                        color: isDarkMode ? '#fff' : '#000',
                                                        border: isDarkMode ? '1px solid rgba(255,255,255,0.1)' : '1px solid #d1d5db',
                                                        borderRadius: '0.75rem',
                                                        boxShadow: isDarkMode ? '0 10px 40px rgba(0,0,0,0.6)' : '0 4px 15px rgba(0,0,0,0.1)',
                                                    }}
                                                    onChange={handleSelectChange}
                                                />
                                                {errors.role && <p className={errorClass}>{errors.role.message}</p>}
                                            </div>

                                            {/* Name */}
                                            <div>
                                                <label className={labelClass} htmlFor="name">
                                                    <FaUserCog size={10} className={isDarkMode ? 'text-sky-400' : 'text-blue-600'} />
                                                    Full Name
                                                    <span className={isDarkMode ? 'text-rose-400' : 'text-red-500'}>*</span>
                                                </label>
                                                <div className="relative">
                                                    <span className={iconWrapClass}>
                                                        <FaUserCog size={9} className={isDarkMode ? 'text-sky-400' : 'text-blue-600'} />
                                                    </span>
                                                    <input
                                                        className={inputClass(errors.name)}
                                                        placeholder="Enter full name"
                                                        type="text"
                                                        id="name"
                                                        {...register('name')}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                                {errors.name && <p className={errorClass}>{errors.name.message}</p>}
                                            </div>

                                            {/* Company Name */}
                                            <div>
                                                <label className={labelClass} htmlFor="company_name">
                                                    <FaBuilding size={10} className={isDarkMode ? 'text-cyan-400' : 'text-blue-600'} />
                                                    Company Name
                                                    <span className={isDarkMode ? 'text-rose-400' : 'text-red-500'}>*</span>
                                                </label>
                                                <div className="relative">
                                                    <span className={iconWrapClass}>
                                                        <FaBuilding size={9} className={isDarkMode ? 'text-cyan-400' : 'text-blue-600'} />
                                                    </span>
                                                    <input
                                                        className={inputClass(errors.company_name)}
                                                        id="company_name"
                                                        type="text"
                                                        placeholder="Enter company name"
                                                        {...register('company_name')}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                                {errors.company_name && <p className={errorClass}>{errors.company_name.message}</p>}
                                            </div>

                                            {/* Email */}
                                            <div>
                                                <label className={labelClass} htmlFor="email">
                                                    <FaEnvelope size={10} className={isDarkMode ? 'text-rose-400' : 'text-red-500'} />
                                                    Email
                                                    <span className={isDarkMode ? 'text-rose-400' : 'text-red-500'}>*</span>
                                                </label>
                                                <div className="relative">
                                                    <span className={iconWrapClass}>
                                                        <FaEnvelope size={9} className={isDarkMode ? 'text-rose-400' : 'text-red-500'} />
                                                    </span>
                                                    <input
                                                        className={inputClass(errors.email)}
                                                        id="email"
                                                        type="email"
                                                        placeholder="Enter email"
                                                        {...register('email')}
                                                    />
                                                </div>
                                                {errors.email && <p className={errorClass}>{errors.email.message}</p>}
                                            </div>

                                            {/* Phone */}
                                            <div>
                                                <label className={labelClass} htmlFor="phone">
                                                    <FaPhone size={10} className={isDarkMode ? 'text-emerald-400' : 'text-blue-600'} />
                                                    Phone
                                                    <span className={isDarkMode ? 'text-rose-400' : 'text-red-500'}>*</span>
                                                </label>
                                                <div className="relative">
                                                    <span className={iconWrapClass}>
                                                        <FaPhone size={9} className={isDarkMode ? 'text-emerald-400' : 'text-blue-600'} />
                                                    </span>
                                                    <input
                                                        className={inputClass(errors.phone)}
                                                        id="phone"
                                                        type="tel"
                                                        maxLength="10"
                                                        placeholder="Enter 10 digit mobile no."
                                                        {...register('phone')}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                                {errors.phone && <p className={errorClass}>{errors.phone.message}</p>}
                                            </div>

                                            {/* Department */}
                                            <div>
                                                <label className={labelClass} htmlFor="department">
                                                    <FaBriefcase size={10} className={isDarkMode ? 'text-amber-400' : 'text-amber-600'} />
                                                    Department
                                                    <span className={isDarkMode ? 'text-rose-400' : 'text-red-500'}>*</span>
                                                </label>
                                                <div className="relative">
                                                    <span className={iconWrapClass}>
                                                        <FaBriefcase size={9} className={isDarkMode ? 'text-amber-400' : 'text-amber-600'} />
                                                    </span>
                                                    <input
                                                        className={inputClass(errors.department)}
                                                        id="department"
                                                        type="text"
                                                        placeholder="Enter department"
                                                        {...register('department')}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                                {errors.department && <p className={errorClass}>{errors.department.message}</p>}
                                            </div>

                                            {/* Password */}
                                            <div>
                                                <label className={labelClass} htmlFor="password">
                                                    <FaLock size={10} className={isDarkMode ? 'text-rose-400' : 'text-red-500'} />
                                                    Password
                                                    <span className={isDarkMode ? 'text-rose-400' : 'text-red-500'}>*</span>
                                                </label>
                                                <div className="relative">
                                                    <span className={iconWrapClass}>
                                                        <FaLock size={9} className={isDarkMode ? 'text-rose-400' : 'text-red-500'} />
                                                    </span>
                                                    <input
                                                        className={`${inputClass(errors.password)} pr-9`}
                                                        id="password"
                                                        type={showPassword ? 'text' : 'password'}
                                                        placeholder="Enter password"
                                                        {...register('password')}
                                                    />
                                                    <span
                                                        className={`absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer transition-colors ${
                                                            isDarkMode ? 'text-gray-500 hover:text-gray-300' : 'text-gray-400 hover:text-gray-600'
                                                        }`}
                                                        onClick={() => setShowPassword(!showPassword)}
                                                    >
                                                        {showPassword ? <FiEyeOff size={13} /> : <FiEye size={13} />}
                                                    </span>
                                                </div>
                                                {errors.password && <p className={errorClass}>{errors.password.message}</p>}
                                            </div>

                                        </div>

                                        {/* Submit */}
                                        <div className={`flex items-center justify-end mt-4 pt-3 border-t gap-2 ${
                                            isDarkMode ? 'border-white/[0.06]' : 'border-gray-100'
                                        }`}>
                                            <button
                                                type="button"
                                                onClick={() => reset()}
                                                className={`text-[10px] font-semibold px-4 py-2 rounded-xl border transition-all duration-300 ${
                                                    isDarkMode
                                                        ? 'text-gray-400 border-white/10 hover:bg-white/5 hover:text-gray-200'
                                                        : 'text-gray-500 border-gray-200 hover:bg-gray-50 hover:text-gray-700'
                                                }`}
                                            >
                                                Reset
                                            </button>
                                            <button
                                                className={`group relative text-[11px] font-bold py-2 px-5 rounded-xl transition-all duration-300 flex items-center gap-2 overflow-hidden ${
                                                    isDarkMode
                                                        ? 'bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 text-white shadow-[0_0_30px_rgba(139,92,246,0.4)] hover:shadow-[0_0_50px_rgba(139,92,246,0.7)] hover:scale-[1.03]'
                                                        : 'bg-blue-600 text-white hover:opacity-85 shadow-sm'
                                                }`}
                                                type="submit"
                                                disabled={isSubmitting}
                                            >
                                                {isDarkMode && !isSubmitting && (
                                                    <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/25 to-transparent translate-x-[-200%] group-hover:translate-x-[200%] transition-transform duration-1000" />
                                                )}
                                                <FaUserPlus size={11} className="relative z-10" />
                                                <span className="relative z-10">{isSubmitting ? "Creating..." : 'Create User'}</span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        {/* Footer Note */}
                        <div className="mt-2 text-center">
                            <p className={`text-[9px] font-medium ${
                                isDarkMode ? 'text-gray-500' : 'text-gray-400'
                            }`}>
                                All fields marked with <span className={isDarkMode ? 'text-rose-400' : 'text-red-500'}>*</span> are required
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddUser;